<template>
  <v-dialog
    :value="value"
    max-width="900"
    content-class="rounded-lg"
    @input="$emit('input', $event)"
  >
    <v-card dark>
      <v-card-title class="d-flex align-center">
        <span>Mask options</span>
        <v-spacer />
        <v-btn icon small @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4 px-4 pb-4">
        <EngravingMaskToolbar
          stacked
          :num-parts="numParts"
          :direction="direction"
          :shape="shape"
          :spacing="spacing"
          :output-size="outputSize"
          @update:num-parts="$emit('update:numParts', $event)"
          @update:direction="$emit('update:direction', $event)"
          @update:shape="$emit('update:shape', $event)"
          @update:spacing="$emit('update:spacing', $event)"
          @update:output-size="$emit('update:outputSize', $event)"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="$emit('input', false)">
          Done
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const ToolbarFallback = { name: 'MaskToolbarFallback', render(h) { return h('div', { class: 'text-caption pa-2' }, 'Mask toolbar failed to load.') } }

export default {
  name: 'MaskOptionsModal',
  components: {
    EngravingMaskToolbar: () =>
      import('../EngravingMask/EngravingMaskToolbar.vue').catch(() => ToolbarFallback),
  },
  props: {
    value: { type: Boolean, default: false },
    numParts: { type: Number, default: 1 },
    direction: { type: String, default: 'horizontal' },
    shape: { type: String, default: 'circle' },
    spacing: { type: Number, default: 0 },
    outputSize: { type: Number, default: 512 },
  },
}
</script>
